import React from 'react';
import ReactDOM from 'react-dom/client';
import {App} from "./pages/app";
import axios from "axios";
import {BrowserRouter} from "react-router-dom";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import Modal from "./components/atoms/modal";
import RouteChangeTracker from './components/routeChangeTracker';

axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_BASE_URL : process.env.REACT_APP_LOCAL_BASE_URL;
axios.defaults.withCredentials = true;

axios.interceptors.request.use(
  request => {
    return request;
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response.status === 409) {
      const {message} = error.response.data;
      if (message !== "코드가 올바르지 않습니다.") alert(message);
    }

    return Promise.reject(error);
  }
);

const queryClient = new QueryClient({
  defaultOptions: {queries: {refetchOnWindowFocus: false, retryOnMount: true, refetchOnReconnect: false, retry: false}},
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter>
    <RouteChangeTracker/>
    <QueryClientProvider client={queryClient}>
      <App/>
      <Modal/>
    </QueryClientProvider>
  </BrowserRouter>
);
